import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import rqLogo from '@/assets/img/logo.svg'
import ClaimAccountButton from '@/components/layouts/ReferralInviteLayout/components/ClaimAccountButton'
import WalkthroughModal from '@/components/layouts/ReferralInviteLayout/components/WalkthroughModal'
import { Button } from '@/components/ui/button'
import { Container } from '@/components/ui/container'
import useDialog from '@/hooks/useDialog'
import { EXTERNAL_LINKS } from '@/lib/constants'
import { faArrowRight } from '@/lib/fontAwesomePro/regular'
import { faQuestionCircle } from '@/lib/fontAwesomePro/solid'

const Header: React.FC = () => {
  const {
    isShowingDialog: isShowingWalkthroughDialog,
    showDialog: showWalkthroughDialog,
    hideDialog: hideWalkthroughDialog,
  } = useDialog()

  return (
    <header
      className="sticky border-b bg-white py-4"
      style={{ minHeight: '80px' }}
    >
      <Container
        className="flex flex-col items-center gap-4 sm:flex-row
          sm:justify-between"
      >
        <a
          href={EXTERNAL_LINKS.marketingWebsite}
          target="_blank"
          rel="opener noreferrer"
        >
          <img src={rqLogo} alt="RQ" style={{ maxWidth: '70px' }} />
        </a>

        <div
          className="flex w-full flex-col gap-y-2 sm:w-auto sm:flex-row"
          style={{ columnGap: '30px' }}
        >
          <Button
            asChild
            className="flex w-full items-center justify-center gap-2
              sm:order-last sm:w-auto"
            size="lg"
            variant="success"
          >
            <ClaimAccountButton>
              Claim your free account
              <FontAwesomeIcon icon={faArrowRight} />
            </ClaimAccountButton>
          </Button>

          <Button
            variant="plain"
            onClick={showWalkthroughDialog}
            className="flex items-center justify-center hover:underline"
            style={{ gap: '6px' }}
          >
            <FontAwesomeIcon
              icon={faQuestionCircle}
              className="relative"
              style={{ fontSize: '16px' }}
            />
            How does RQ work?
          </Button>
        </div>
      </Container>

      {isShowingWalkthroughDialog && (
        <WalkthroughModal onHide={hideWalkthroughDialog} />
      )}
    </header>
  )
}

export default Header
